<template>
  <aha-button class="present-button" size="sm" @click="handlePresentNowButtonClick">
    <aha-icon
      v-if="!isCheckingPerm"
      name="play"
      width="10"
      height="10"
      viewBox="0 0 24 24"
    />
    <aha-spinner variant="white" v-else />
    <span class="ml-1">{{ $i18nPresenter.t("Present") }}</span>
  </aha-button>
</template>

<script>
import eventCategories from '@/constant/eventCategories'
import msTeamsUtils from '@/utils/ms-teams'
import util from '@/util'
import mixpanelUtils from '@/utils/mixpanel.utils'

export default {
  props: {
    presentation: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isCheckingPerm: false,
    }
  },
  methods: {
    async handlePresentNowButtonClick() {
      if (this.$store.state.isMSTeamsApp) {
        await msTeamsUtils.setPresentContext(this.$store.state.presentation)
        return
      }

      this.isCheckingPerm = true
      const hasPerm = await this.$func.isCurrentEditorRealtime(this.presentation, this)
      this.isCheckingPerm = false
      if (!hasPerm) return
      mixpanelUtils.register(mixpanelUtils.getPresentationContext(this.presentation))
      const customProps = {
        ...mixpanelUtils.getPresentationContext(this.presentation),
        ...util.getSlideCountObject(this.presentation),
      }
      util.mixpanelTracking(
        eventCategories.PRESENTATION_LIST,
        'start presenting',
        'Presentation List > Present Button',
        this.presentation.id,
        customProps,
      )
      this.$router.push({
        name: 'PresentationDetail',
        params: {
          id: this.presentation.id,
        },
        query: {
          presenting: true,
        },
      })
    },
  },
}
</script>
